import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { UntypedFormArray } from "@angular/forms";
import { merge, Subscription } from "rxjs";
import { CONSTANT } from "src/app/constant";
import { SharedService } from "src/app/shared/services/shared.service";
import { buildOverallObCountSummary, emptyObCountSummary, ObCountSummary } from "../ts1-overall-ob-count.utils";

@Component({
	selector: "app-ts1-overall-ob-count-summary",
	templateUrl: "./ts1-overall-ob-count-summary.component.html",
	styleUrls: ["./ts1-overall-ob-count-summary.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class Ts1OverallObCountSummaryComponent implements OnInit, OnChanges, OnDestroy {
	@Input() maneuvers!: UntypedFormArray;
	@Input() formTypeCode: string | null = null;

	expanded = true;
	summary: ObCountSummary = emptyObCountSummary([]);

	private sub?: Subscription;

	constructor(private sharedService: SharedService) {}

	ngOnInit(): void {
		this.refreshSummary();
		this.sub = merge(this.maneuvers.valueChanges, this.maneuvers.statusChanges).subscribe(() => {
			this.refreshSummary();
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes["formTypeCode"]) {
			this.refreshSummary();
		}
	}

	ngOnDestroy(): void {
		this.sub?.unsubscribe();
	}

	toggleExpanded(): void {
		this.expanded = !this.expanded;
	}

	private refreshSummary(): void {
		const obTypes = this.resolveObTypes();
		const maneuverValues = this.maneuvers.controls.map((control) => control.value as Record<string, unknown>);
		this.summary = buildOverallObCountSummary(maneuverValues, obTypes);
	}

	private resolveObTypes(): string[] {
		const code = this.formTypeCode ?? CONSTANT.FORM_TYPE.ts_1;
		const list = this.sharedService.generateSortedOBList(code) ?? [];
		return list.map((ob: { title: string }) => ob.title);
	}
}
